import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import * as Sentry from "@sentry/react";

// Initiera Sentry
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN || "", // Sätt DSN via miljövariabel
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Fånga 100% av transaktioner (sänk i produktion om hög trafik)
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% av normala sessioner
    replaysOnErrorSampleRate: 1.0, // 100% av sessioner med errors

    environment: process.env.NODE_ENV || 'development',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
